/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
    color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path d="M21 7.58594V6.08594C21 5.5555 20.7893 5.0468 20.4142 4.67172C20.0391 4.29665 19.5304 4.08594 19 4.08594H5C4.46957 4.08594 3.96086 4.29665 3.58579 4.67172C3.21071 5.0468 3 5.5555 3 6.08594V20.0859C3 20.6164 3.21071 21.1251 3.58579 21.5002C3.96086 21.8752 4.46957 22.0859 5 22.0859H8.5M16 2.08594V6.08594M8 2.08594V6.08594M3 10.0859H8M17.5 17.5859L16 16.3859V14.0859M22 16.0859C22 19.3996 19.3137 22.0859 16 22.0859C12.6863 22.0859 10 19.3996 10 16.0859C10 12.7722 12.6863 10.0859 16 10.0859C19.3137 10.0859 22 12.7722 22 16.0859Z"
      stroke={ color? color : "#262626"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
